const divisa = {
  readDivisas: 'divisas'
}

export default divisa
